module.exports = __webpack_public_path__ + "static/img/10008.71032805.png";